import { observer } from 'mobx-react-lite';
import FormContainer from './FormContainer';
import FormLabel from './FormLabel';

export default observer(({ children = null, required = false, label = '', center }) => (
  <FormContainer center={center}>
    <FormLabel>
      {required && '*'} {label}
    </FormLabel>
    <div>{children}</div>
  </FormContainer>
));
